
import './components';

// Import AutomatorRecipeTemplateLibrary
import AutomatorRecipeTemplateLibrary from './automator-recipe-template-library';

// Import dom-ready
import domReady from '@wordpress/dom-ready';

// Import style
import './style.scss';

/**
 * Class TemplateLibrary - Page functionality.
 *
 */
export default class TemplateLibrary {
	/**
	 * Creates an instance of the TemplateLibrary class,
	 *
	 */
	constructor() {
		if ( this.isTemplateLibraryPage() ) {
			new AutomatorRecipeTemplateLibrary();
		}
	}

	/**
	 * Determines if the current page is the "Template Library" page.
	 *
	 * @return {Boolean} True if the current page is the "Template Library" page, otherwise false.
	 */
	isTemplateLibraryPage() {
		return document.getElementById( 'uap-template-library' ) !== null;
	}
}

domReady( () => {
	new TemplateLibrary();
} );
